export const parseYoutubeVideoId = (url: string | null | undefined): string | null => {
  if (!url?.trim()) return null;
  const u = url.trim();

  const short = u.match(/youtu\.be\/([a-zA-Z0-9_-]{11})(?:\?|$)/);
  if (short?.[1]) return short[1];

  const watch = u.match(/[?&]v=([a-zA-Z0-9_-]{11})(?:&|$)/);
  if (watch?.[1]) return watch[1];

  const embed = u.match(/youtube\.com\/embed\/([a-zA-Z0-9_-]{11})(?:\?|$)/);
  if (embed?.[1]) return embed[1];

  const shorts = u.match(/youtube\.com\/shorts\/([a-zA-Z0-9_-]{11})(?:\?|$)/);
  if (shorts?.[1]) return shorts[1];

  return null;
}



export const youtubeEmbedUrl = (videoId: string): string => {
  return `https://www.youtube.com/embed/${videoId}?rel=0`;
}
